import { AvailableLanguages } from '@repo/toolkit/language-types'

export const FileSelectionLocaleKeys = [
  'photosLabel',
  'photosAction',
  'videosLabel',
  'videosAction',
  'documentsLabel',
  'documentsAction',
  'uploadFile',
  'dragAndDrop',
  'files'
] as const

export type FileSelectionLocaleKeys = (typeof FileSelectionLocaleKeys)[number]

export const fileSelectionLocaleMapping: Record<
  AvailableLanguages,
  Record<FileSelectionLocaleKeys, string>
> = {
  en: {
    photosLabel: 'Photos',
    photosAction: 'Upload photos',
    videosLabel: 'Videos',
    videosAction: 'Upload videos',
    documentsLabel: 'Documents',
    documentsAction: 'Upload documents',
    uploadFile: 'Upload file',
    dragAndDrop: 'Drag and drop or browse',
    files: 'Files'
  },
  fr: {
    photosLabel: 'Photos',
    photosAction: 'Télécharger des photos',
    videosLabel: 'Vidéos',
    videosAction: 'Télécharger des vidéos',
    documentsLabel: 'Documents',
    documentsAction: 'Télécharger des documents',
    uploadFile: 'Télécharger le fichier',
    dragAndDrop: 'Glisser-déposer ou parcourir',
    files: 'Fichiers'
  }
}
